module.exports = __webpack_public_path__ + "static/media/Thumbnail4.479f8e8e.png";